module.exports = "<app-reports-cmp></app-reports-cmp>\n"